export * from './post-mitarbeiter.component';
export * from './post-mitarbeiter.component.module';